import React, { useState } from 'react';

import { Alert, Button, Form, Modal } from 'react-bootstrap';

const ModalSMS = (props: any) => {
  const [index, setIndex] = useState(0);

  const handleClose = () => {
    props.setShow(false);
  };

  const nextInput = (e: any) => {
    const form = e.target.form;
    if (form.elements[index + 1] !== undefined) {
      form.elements[index + 1].focus();
      setIndex(index + 1);
    }
  };

  return (
    <Modal className="d-flex flex-column" centered={true} show={props.show} onHide={handleClose}>
      <Button className=" ms-auto" variant="none" onClick={handleClose}>
        <i className="bi bi-x-lg"></i>
      </Button>
      <Form noValidate onSubmit={props.handleSubmit} onChange={nextInput}>
        <div className="py-3 px-1 px-sm-5 d-flex flex-column">
          <h1 className="register-title text-center mb-0">Verification</h1>
          <h2 className="register-subtitle2 text-center mt-0 px-3">Merci d’entrer le code reçu par SMS</h2>

          <div className="input-group-text input-group-lg gap-4 my-5 px-sm-0 px-md-5 mt-4 mb-4 d-flex ">
            {[...Array(props.length)].map((_, index) => {
              return (
                <input
                  key={index}
                  type="text"
                  className="form-control text-center smsInput"
                  maxLength={1}
                  aria-label="Text input with radio button"
                  required
                />
              );
            })}
          </div>

          {props.errorCode !== '' && (
            <Alert variant="danger" className="text-center">
              {props.errorCode}
            </Alert>
          )}

          <Button className="mx-auto w-50 text-center mb-4" type="submit">
            Confirmer
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
export default ModalSMS;
